import React from 'react'
import ReactDOM from 'react-dom/client'
import './translations/i18n'
import { Provider } from 'react-redux'
import { MsalProvider } from '@azure/msal-react'
import store from './store'
import App from './App'
import moment from 'moment-timezone'
import { msalInstance } from './components/auth/microsoftAuth'

moment.tz.setDefault('Europe/Madrid')

window.jwt = ''

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
	<Provider store={store}>
		<MsalProvider instance={msalInstance}>
			<React.StrictMode>
				<App />
			</React.StrictMode>
		</MsalProvider>
	</Provider>
)